module.exports = __webpack_public_path__ + "../front/img/468_bøjestang+1hylde.f08ce46b.svg";